import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '@app/shared/components/dialogs/alert-dialog/alert-dialog.component';
import { NotifyOptions } from '../models/notify-options.model';

const ERROR_ALERT_DIALOG_ID = 'error-alert-dialog';
const SESSION_ANNOUNCEMENT_KEY = 'session-notification-acknowledged';

/**
 * NotificationService
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  /**
   * constructor
   * @param {MatDialog} dialog
   */
  constructor(private dialog: MatDialog) {}

  /**
   * error
   * @param {NotifyOptions} options
   */
  error(options: NotifyOptions): void {
    if (this.shouldSuppressSessionAnnouncement(options)) {
      return;
    }

    const openDialogs = ((this.dialog as any).openDialogs ?? []) as Array<{
      id?: string;
    }>;
    if (
      openDialogs.some(dialogRef => dialogRef?.id === ERROR_ALERT_DIALOG_ID)
    ) {
      return;
    }

    if (this.isSessionAnnouncement(options)) {
      this.setSessionAnnouncementShown();
    }

    this.dialog.open(AlertDialogComponent, {
      disableClose: true,
      closeOnNavigation: true,
      id: ERROR_ALERT_DIALOG_ID,
      panelClass: 'error-alert-dialog',
      width: '364px',
      maxWidth: '90vw',
      data: {
        ...options,
      },
    });
  }

  private shouldSuppressSessionAnnouncement(options: NotifyOptions): boolean {
    return (
      this.isSessionAnnouncement(options) && this.wasSessionAnnouncementShown()
    );
  }

  private isSessionAnnouncement(options: NotifyOptions): boolean {
    return (
      options?.title === 'Notification' &&
      options?.confirmBtnText === 'Acknowledged'
    );
  }

  private wasSessionAnnouncementShown(): boolean {
    const storage = this.getSessionStorage();
    return storage
      ? storage.getItem(SESSION_ANNOUNCEMENT_KEY) === 'true'
      : false;
  }

  private setSessionAnnouncementShown(): void {
    const storage = this.getSessionStorage();
    if (storage) {
      storage.setItem(SESSION_ANNOUNCEMENT_KEY, 'true');
    }
  }

  private getSessionStorage(): Storage | null {
    if (typeof window === 'undefined') {
      return null;
    }

    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }
}
